import {
  DateNone,
  IHousesShotInfo,
  IStudentStripeMatches,
} from "interfaces/intarfaces";

export interface IError {
  status: number;
  errorMessages: Array<[string, string]>;
}

export function generateErrorResponse(error: any): IError {
  try {
    const {
      response: { status, data },
    } = error;

    let errorMessages: Array<[string, string]> = [["Error:", ""]];
    if (status === 422) {
      return {
        status,
        errorMessages: [["Error:", "Something went wrong, 422"]],
      };
    } else if (data.hasOwnProperty("detail"))
      if (typeof data.detail === "string")
        return {
          status,
          errorMessages: data.detail,
        };
      else errorMessages = data.detail.map((err: any) => [err.loc[1], err.msg]);
    else if (data.hasOwnProperty("message")) {
      let response_message: string = data["message"];
      if (response_message.indexOf("<User:") > -1) {
        errorMessages =
          response_message.lastIndexOf("not found") > -1
            ? [["Error:", "This user is not existing"]]
            : [["Error:", "User with this email existing"]];
      }
    } else errorMessages = [["Error 100:", data]];
    return {
      status,
      errorMessages,
    };
  } catch (error_any) {
    console.log(error_any);
  }

  return {
    status: 0,
    errorMessages: [["Error: 101", error]],
  };
}

export const getImg = async (file: any): Promise<string | undefined> => {
  let src = file.url;
  if (!src) {
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result as string);
    });
  }
  return undefined;
};

export const getBase64 = async (file: File): Promise<string | undefined> => {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => resolve(undefined);
  });
};

export const makeFile = async (
  x: string | undefined
): Promise<File | undefined> => {
  if (x === undefined) return undefined;
  const response = await fetch(x);
  const blob = await response.blob();
  return new File([blob], `file${new Date().toTimeString()}`, {
    type: response.type,
  });
};

export const isoDate = (date: Date | undefined) =>
  date
    ? Object.prototype.toString.call(date) === "[object Date]"
      ? date.toISOString().slice(0, 10)
      : ""
    : "";

export const convertTime = (date: string, local: boolean = true) => {
  let newDate = new Date(date + (local ? "Z" : ""));
  const formatedDate = newDate.toLocaleDateString("en-EN").replaceAll("/", "-");
  const HHMM = newDate.toLocaleTimeString("uk-UA").substr(0, 5);
  return `${formatedDate} ${HHMM}`;
};

export const getPeriod = () => {
  const date = new Date();
  date.setDate(date.getDate() + 14);
  return { value: new Date(), endInterval: date };
};

export const getDateOrNone = (dateCandidate: DateNone | string) => {
  if (dateCandidate === undefined) return undefined;
  try {
    return new Date(dateCandidate);
  } catch {
    return undefined;
  }
};

export const isDateInPeriod = (
  date: string,
  from_date: string,
  to_date: string
) => date >= from_date && date <= to_date;

export const isEmptyItem = (item: any) => !item;

export const filterMatches = (
  a: IStudentStripeMatches,
  b: IStudentStripeMatches
) => {
  if (a.period.start > b.period.start) return 1;
  if (a.period.start < b.period.start) return -1;
  return 0;
};

export const filterHouses = (a: IHousesShotInfo, b: IHousesShotInfo) => {
  if (a.available_from > b.available_from) return 1;
  if (a.available_from < b.available_from) return -1;
  return a.title.localeCompare(b.title);
};

export const setTimeoutAsync = (cb: Function, delay: number) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(cb());
    }, delay);
  });
